var _style, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path2, _g10, _g11, _g12, _g13, _g14, _path3, _g15, _g16, _g17, _polygon, _defs, _g18, _g19, _g20, _polygon2, _g21, _defs2, _g22, _g23, _g24, _g25, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutheticationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 250",
    style: {
      enableBackground: "new 0 0 450 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;}\r\n\t.st1{fill:#D3D3D3;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#A6A5A5;}\r\n\t.st4{opacity:0.3;}\r\n\t.st5{fill:#F2F1EF;}\r\n\t.st6{opacity:0.57;}\r\n\t.st7{clip-path:url(#SVGID_00000138535046482851993140000007639660993686058912_);}\r\n\t.st8{clip-path:url(#SVGID_00000183930972364815974660000017503670092886542501_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63203",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3069"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3324",
    className: "st1",
    cx: 97.809,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3070"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3325",
    className: "st1",
    cx: 107.477,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3071"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3326",
    className: "st1",
    cx: 117.146,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3072"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3327",
    className: "st1",
    cx: 126.814,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3073"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3328",
    className: "st1",
    cx: 136.482,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3074"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3329",
    className: "st1",
    cx: 146.151,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3075"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3330",
    className: "st1",
    cx: 155.82,
    cy: 37.3065,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3076"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3331",
    className: "st1",
    cx: 97.809,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3077"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3332",
    className: "st1",
    cx: 107.477,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3078"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3333",
    className: "st1",
    cx: 117.146,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3079"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3334",
    className: "st1",
    cx: 126.814,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3080"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3335",
    className: "st1",
    cx: 136.482,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3081"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3336",
    className: "st1",
    cx: 146.151,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3082"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3337",
    className: "st1",
    cx: 155.82,
    cy: 45.8625,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3083"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3338",
    className: "st1",
    cx: 97.809,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3084"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3339",
    className: "st1",
    cx: 107.477,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3085"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3340",
    className: "st1",
    cx: 117.146,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3086"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3341",
    className: "st1",
    cx: 126.814,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3087"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3342",
    className: "st1",
    cx: 136.482,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3088"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3343",
    className: "st1",
    cx: 146.151,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3089"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3344",
    className: "st1",
    cx: 155.82,
    cy: 54.4165,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3090"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3345",
    className: "st1",
    cx: 97.809,
    cy: 62.9715,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3091"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3346",
    className: "st1",
    cx: 107.477,
    cy: 62.9715,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3092"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3347",
    className: "st1",
    cx: 117.146,
    cy: 62.9715,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3093"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3348",
    className: "st1",
    cx: 126.814,
    cy: 62.9715,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3094"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3349",
    className: "st1",
    cx: 136.482,
    cy: 62.9715,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3095"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3350",
    className: "st1",
    cx: 146.151,
    cy: 62.9715,
    r: 2.783
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3096"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3351",
    className: "st1",
    cx: 155.82,
    cy: 62.9715,
    r: 2.783
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55083",
    className: "st2",
    d: "M143.024,53.1235h149.742c12.2316-0.0011,22.1483,9.9134,22.15,22.145v88.368 c0.0016,12.2322-9.9128,22.1498-22.145,22.152H143.024c-12.232,0-22.148-9.916-22.148-22.148c0-0.0013,0-0.0027,0-0.004l0,0 v-88.368C120.8777,63.0377,130.7932,53.1235,143.024,53.1235z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.1241,49.5608h-170.46c-8.46,0.03-15.3201,6.8899-15.3499,15.3499v109.0801 c0.0298,8.47,6.8899,15.3201,15.3499,15.3501h81.55v8.1199h-22.6499c-2.9602,0-5.6401,1.2-7.5801,3.1399 c-1.9399,1.9402-3.1401,4.6201-3.1401,7.5801h74.1001c0-5.9199-4.8-10.72-10.72-10.72H221.574v-8.1199h81.55 c8.47-0.03,15.3201-6.8901,15.3501-15.3501V64.9107C318.4441,56.4507,311.594,49.5909,303.1241,49.5608z M311.354,173.9908 c-0.01,4.54-3.6899,8.22-8.23,8.23h-170.46c-4.54-0.01-8.21-3.6899-8.23-8.22V64.9107c0.02-4.54,3.6899-8.21,8.23-8.23h170.46 c4.54,0.02,8.21,3.6899,8.23,8.23V173.9908z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63267",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_54835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55087",
    className: "st2",
    d: "M242.285,48.9775l-131.424,131.424l16.185,16.185l147.609-147.609 C274.655,48.9775,242.285,48.9775,242.285,48.9775z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63269",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_54836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55088",
    className: "st2",
    d: "M319.047,65.6765l-142.6,142.6l7.19,7.2l135.4-135.4L319.047,65.6765z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63271",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_54837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55089",
    className: "st2",
    d: "M306.63,49.1725h-7.8l-146.151,146.152l7.5,7.5l151.47-151.47l-0.359-0.359L306.63,49.1725z "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3107"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3352",
    className: "st2",
    cx: 206.536,
    cy: 53.4265,
    r: 1.702
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55090",
    className: "st2",
    d: "M211.757,52.8205h18.592c0.3352,0,0.607,0.2718,0.607,0.607l0,0 c0,0.3347-0.2713,0.606-0.606,0.606c-0.0003,0-0.0007,0-0.001,0h-18.592c-0.3347,0.0005-0.6064-0.2703-0.607-0.605 c0-0.0003,0-0.0007,0-0.001l0,0C211.15,53.0923,211.4218,52.8205,211.757,52.8205z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63521",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15246",
    className: "st3",
    d: "M117.366,138.8405h15.257c5.3621,0,9.709,4.3469,9.709,9.709l0,0v40.723l0,0h-24.966l0,0 V138.8405L117.366,138.8405z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63522",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15247",
    className: "st3",
    d: "M313.103,188.8965h-39.269l0,0v-62.089c0-8.318,6.743-15.061,15.061-15.061l0,0h24.208 l0,0V188.8965L313.103,188.8965z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55091",
    className: "st2",
    d: "M104.977,143.1255h27.2c2.9782,0.0005,5.3925,2.4148,5.393,5.393v52.592 c-0.0005,2.9782-2.4148,5.3925-5.393,5.393h-27.2c-2.9781-0.0005-5.392-2.4149-5.392-5.393v-52.592 C99.585,145.5404,101.9989,143.1261,104.977,143.1255z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55093",
    className: "st1",
    d: "M108.382,186.9085h20.394c0.787,0.0005,1.4245,0.639,1.424,1.426c0,0.0007,0,0.0013,0,0.002 v0.223c0.0005,0.787-0.637,1.4254-1.424,1.426c-0.0007,0-0.0013,0-0.002,0h-20.392c-0.787,0.0005-1.4254-0.637-1.426-1.424 c0-0.0007,0-0.0013,0-0.002v-0.223c-0.0017-0.787,0.635-1.4263,1.422-1.428 C108.3793,186.9085,108.3807,186.9085,108.382,186.9085z"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55094",
    className: "st1",
    d: "M108.382,192.4845h20.394c0.7876,0,1.426,0.6384,1.426,1.426c0,0.0003,0,0.0007,0,0.001 v0.223c0,0.7876-0.6384,1.426-1.426,1.426h-20.394c-0.7876,0-1.426-0.6384-1.426-1.426v-0.223 c-0.0006-0.7876,0.6374-1.4265,1.425-1.427C108.3813,192.4845,108.3817,192.4845,108.382,192.4845z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.177,141.5535h-27.2c-3.8452,0.0039-6.9617,3.1199-6.9661,6.9651v52.5918 c0.0044,3.8452,3.1208,6.9612,6.9661,6.9651h27.2c3.8452-0.0039,6.9614-3.1199,6.9661-6.9651v-52.5918 C139.1385,144.6734,136.0222,141.5574,132.177,141.5535z M135.9971,201.1104c-0.0027,2.1086-1.7114,3.8174-3.8201,3.8201h-27.2 c-2.1086-0.0027-3.8174-1.7114-3.8201-3.8201v-52.5918c0.0027-2.1086,1.7114-3.8174,3.8201-3.8201h7.6228v0.22 c-0.002,1.2603,1.0178,2.2837,2.2781,2.2859c0.0002,0,0.0007,0,0.001,0h7.387c1.2605,0.0017,2.2834-1.0186,2.2852-2.2791v-0.2268 h7.626c2.1086,0.0027,3.8174,1.7114,3.8201,3.8201v52.5918H135.9971z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63322",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55096",
    className: "st5",
    d: "M53.321,208.5535h343.354c1.8348,0,3.3228,1.4862,3.325,3.321l0,0 c-0.0022,1.8348-1.4902,3.321-3.325,3.321H53.321c-1.8332-0.0022-3.3188-1.4878-3.321-3.321l0,0 C50.0028,210.0415,51.488,208.5562,53.321,208.5535z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63525",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15248",
    className: "st1",
    d: "M225.737,87.1495h60.796c2.8067,0,5.082,2.2753,5.082,5.082v30.519 c0,2.8067-2.2753,5.082-5.082,5.082h-60.796c-2.8067,0-5.082-2.2753-5.082-5.082v-30.519 C220.655,89.4248,222.9303,87.1495,225.737,87.1495z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63526",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15249",
    className: "st1",
    d: "M222.845,137.3665h70.339c0.993,0,1.798,0.805,1.798,1.798v4.207 c0,0.993-0.805,1.798-1.798,1.798h-70.339c-0.993,0-1.798-0.805-1.798-1.798v-4.207 C221.047,138.1715,221.852,137.3665,222.845,137.3665z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63527",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15250",
    className: "st1",
    d: "M222.845,151.1285h70.339c0.993,0,1.798,0.805,1.798,1.798v4.207 c0,0.993-0.805,1.798-1.798,1.798h-70.339c-0.993,0-1.798-0.805-1.798-1.798v-4.207 C221.047,151.9335,221.852,151.1285,222.845,151.1285z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55097",
    className: "st2",
    d: "M289.077,117.6415h54.005c4.9639,0,8.988,4.0241,8.988,8.988l0,0v70.189 c-0.0005,4.9635-4.0244,8.987-8.988,8.987h-54.005c-4.9636,0-8.9875-4.0235-8.988-8.987v-70.189 C280.089,121.6656,284.1131,117.6415,289.077,117.6415L289.077,117.6415z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343.0821,115.3946H289.077c-6.2019,0.0071-11.2278,5.033-11.2349,11.2349v70.189 c0.0071,6.2019,5.0332,11.2275,11.2349,11.2341h54.0051c6.2017-0.0066,11.2278-5.0322,11.2349-11.2341v-70.189 C354.3098,120.4275,349.284,115.4017,343.0821,115.3946z M349.823,196.8184c-0.0044,3.7212-3.02,6.7368-6.741,6.7412h-54.0051 c-3.7212-0.0044-6.7366-3.02-6.741-6.7412v-70.189c0.0044-3.7212,3.0198-6.7366,6.741-6.741h15.6782v0.2471 c0,1.7529,1.9287,3.177,4.3169,3.1799h14c2.3879,0,4.3269-1.417,4.3311-3.1699v-0.2571h15.679 c3.7209,0.0044,6.7366,3.0198,6.741,6.741L349.823,196.8184L349.823,196.8184z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63221-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63220-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15053-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55100",
    className: "st1",
    d: "M299.009,179.1365h33.266c0.9941,0,1.8,0.8059,1.8,1.8v1.617c0,0.9941-0.8059,1.8-1.8,1.8 h-33.266c-0.9941,0-1.8-0.8059-1.8-1.8v-1.617C297.209,179.9424,298.0149,179.1365,299.009,179.1365z"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63223-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63222-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15054-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55101",
    className: "st1",
    d: "M299.009,188.5915h33.266c0.9941,0,1.8,0.8059,1.8,1.8v1.617c0,0.9941-0.8059,1.8-1.8,1.8 h-33.266c-0.9941,0-1.8-0.8059-1.8-1.8v-1.617C297.209,189.3974,298.0149,188.5915,299.009,188.5915z"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63530"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3353",
    className: "st2",
    cx: 172.781,
    cy: 119.1145,
    r: 30.013
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55102",
    className: "st3",
    d: "M172.782,151.3745c-17.8167,0-32.26-14.4433-32.26-32.26s14.4433-32.26,32.26-32.26 s32.26,14.4433,32.26,32.26l0,0C205.0199,136.9221,190.5896,151.3525,172.782,151.3745z M172.782,91.3485 c-15.3353-0.0005-27.7674,12.4307-27.768,27.766s12.4307,27.7674,27.766,27.768s27.7674-12.4307,27.768-27.766 c0-0.0007,0-0.0013,0-0.002C200.5293,103.7875,188.109,91.3672,172.782,91.3485z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "186.4881,129.3516 177.1805,120.0435 186.4854,110.7386 182.0376,106.2908 172.7327,115.5958  163.4236,106.2862 158.9749,110.7344 168.2845,120.044 158.9759,129.3526 163.4236,133.8003 172.732,124.492 182.0398,133.7999 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63538",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M289.074,115.3965h54.007c6.2049,0,11.235,5.0301,11.235,11.235v70.185 c0,6.2049-5.0301,11.235-11.235,11.235h-54.007c-6.2049,0-11.235-5.0301-11.235-11.235v-70.185 C277.839,120.4266,282.8691,115.3965,289.074,115.3965z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033340129589076986560000008349258381091231400_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63537",
    style: {
      clipPath: "url(#SVGID_00000033340129589076986560000008349258381091231400_)"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63534"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15253",
    x: 235.1688,
    y: 146.2953,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.837 254.4126)",
    className: "st2",
    width: 123.0318,
    height: 12.1269
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63535"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15254",
    x: 252.1333,
    y: 155.3731,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.7089 268.4135)",
    className: "st2",
    width: 123.0318,
    height: 7.6629
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63536"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15255",
    x: 265.1495,
    y: 169.6053,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -26.1004 281.4296)",
    className: "st2",
    width: 123.0318,
    height: 5.231
  }))))))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "324.7146,146.1849 321.5376,143.0079 316.0481,148.4974 310.5591,143.0083 307.3821,146.1856  312.8709,151.6744 307.3821,157.1636 310.5591,160.3404 316.0481,154.8516 321.5376,160.3411 324.7146,157.1641 319.2251,151.6744  "
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55103",
    className: "st3",
    d: "M316.08,171.0975c-11.0424,0.0005-19.9944-8.9506-19.995-19.993s8.9507-19.9944,19.993-19.995 c11.0424-0.0005,19.9944,8.9506,19.995,19.993c0,0.0007,0,0.0013,0,0.002C336.0603,162.1411,327.1166,171.0848,316.08,171.0975z  M316.08,134.2565c-9.3049-0.0005-16.8484,7.5421-16.849,16.847c-0.0005,9.3049,7.5421,16.8484,16.847,16.849 c9.3049,0.0005,16.8484-7.5421,16.849-16.847c0-0.0003,0-0.0007,0-0.001C332.9171,141.8041,325.3804,134.267,316.08,134.2565z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63546",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119117480721436243630000013926907103402780060_",
    d: "M104.978,141.5505h27.196 c3.8472,0,6.966,3.1188,6.966,6.966v52.595c0,3.8472-3.1188,6.966-6.966,6.966h-27.196c-3.8472,0-6.966-3.1188-6.966-6.966 v-52.595C98.012,144.6693,101.1308,141.5505,104.978,141.5505z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157266025499171208330000015251663861435111566_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119117480721436243630000013926907103402780060_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63545",
    style: {
      clipPath: "url(#SVGID_00000157266025499171208330000015251663861435111566_)"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63542"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15259",
    x: 50.6607,
    y: 157.6251,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -83.7236 124.4525)",
    className: "st2",
    width: 115.4099,
    height: 11.3289
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63543"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15260",
    x: 59.7492,
    y: 169.9371,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -87.4882 133.541)",
    className: "st2",
    width: 115.4099,
    height: 4.882
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63544"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15261",
    x: 67.647,
    y: 177.8352,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -90.7597 141.4389)",
    className: "st2",
    width: 115.4099,
    height: 4.882
  }))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55104",
    className: "st3",
    d: "M118.863,178.9365c-6.4385,0.0005-11.6584-5.2185-11.659-11.657 c-0.0005-6.4385,5.2185-11.6584,11.657-11.659s11.6584,5.2185,11.659,11.657c0,0.0007,0,0.0013,0,0.002 C130.5123,173.7143,125.2978,178.9288,118.863,178.9365z M118.863,157.8685c-5.197,0-9.41,4.213-9.41,9.41s4.213,9.41,9.41,9.41 c5.1966,0,9.4095-4.2124,9.41-9.409c-0.0077-5.1935-4.2165-9.4014-9.41-9.408C118.863,157.8715,118.863,157.8685,118.863,157.8685z "
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "123.846,164.5132 121.9397,162.6067 118.8445,165.702 115.75,162.6075 113.844,164.5135  116.9385,167.608 113.844,170.7024 115.7503,172.6089 118.845,169.5142 121.9385,172.608 123.8445,170.7017 120.751,167.6082 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutheticationError);
export default __webpack_public_path__ + "static/media/AutheticationError.a93981f963a80389d88586e5e60abb0f.svg";
export { ForwardRef as ReactComponent };